/**
 * @owner @Appboy/currents-review
 */
import type { FeatureName } from "@lib/featureFlipper";

export const isDeltashareAvailable = (featureOn: (featureName: FeatureName) => boolean): boolean =>
  featureOn("databricks_deltashare") || featureOn("delta_sharing_beta");
